import { render, staticRenderFns } from "./QuestionLong.vue?vue&type=template&id=d68395d6&scoped=true&"
import script from "./QuestionLong.vue?vue&type=script&lang=ts&"
export * from "./QuestionLong.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68395d6",
  null
  
)

export default component.exports